import { useStore } from "@/stores";
import { computed, type Ref } from "vue";

export function useUploadImage(image: Ref<string | undefined>) {
  const { uploadDirectory } = useStore();
  const imageUrl = computed(() =>
    image.value ? `${uploadDirectory}/${image.value}` : ""
  );

  return { imageUrl };
}
